export default __webpack_public_path__ + "videodb1934.mp4";